import React from "react";
import { Link } from "react-router-dom";
function FAQs() {
  return (
    <div className=" xl:px-32 lg:px-24 md:px-16 px-10 pt-6 py-8  shadow-md">
      <h1 className="text-3xl font-semibold mb-6">
        Frequently Asked Questions
      </h1>

      {/* FAQ Item 1 */}
      <details className="mb-6">
        <summary className="text-xl font-semibold cursor-pointer">
          What services does Keyline Solution offer?
        </summary>
        <p>
          Keyline Solution offers a range of printing services, including
          digital printing, litho printing, and large format printing. We also
          provide a free design service to our customers.
        </p>
      </details>

      {/* FAQ Item 2 */}
      <details className="mb-6">
        <summary className="text-xl font-semibold cursor-pointer">
          How can I request a quote for printing services?
        </summary>
        <p>
          You can request a quote by visiting our{" "}
          <Link to="/contact" className="text-blue-500 hover:underline">
            Contact Us
          </Link>{" "}
          page and filling out the inquiry form. Alternatively, you can call us
          at{" "}
          <Link
            to="tel:+92 333 448 7714"
            className="text-blue-500 hover:underline"
          >
            +92 333 448 7714
          </Link>{" "}
          or email us at{" "}
          <Link
            to="mailto:ahsan@keylinesolution.com"
            className="text-blue-500 hover:underline"
          >
            ahsan@keylinesolution.com
          </Link>
          .
        </p>
      </details>

      {/* FAQ Item 3 */}
      <details className="mb-6">
        <summary className="text-xl font-semibold cursor-pointer">
          What is the turnaround time for printing orders?
        </summary>
        <p>
          The turnaround time for printing orders may vary depending on the type
          of service and the complexity of the project. We will provide you with
          an estimated delivery time when you request a quote.
        </p>
      </details>

      {/* FAQ Item 4 */}
      <details className="mb-6">
        <summary className="text-xl font-semibold cursor-pointer">
          Can I provide my own design for printing?
        </summary>
        <p>
          Yes, you can provide your own design for printing. Our team can work
          with a wide range of file formats. If you need assistance with design,
          we also offer a free design service.
        </p>
      </details>

      {/* FAQ Item 5 */}
      <details className="mb-6">
        <summary className="text-xl font-semibold cursor-pointer">
          What payment methods do you accept?
        </summary>
        <p>
          We accept various payment methods, including credit cards, debit
          cards, and bank transfers. Please contact us for specific payment
          details and options.
        </p>
      </details>

      {/* ... (Add more FAQ items as needed) */}
    </div>
  );
}

export default FAQs;
